import FakeVideosContent from "@assets/images/FakeVideosContent"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { ArticleTypes } from "@Constants/constant"
import { Ionicons } from "@expo/vector-icons"
import React from "react"
import { Image, TouchableOpacity, View } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"
import styles from "./styles"
import VideoMiniature from "@assets/images/VideoMiniature.png"

const CustomVideoItem = (props) => {
    const { item, handlePress } = props

    return (
        <TouchableOpacity
            onPress={handlePress(item)} //replace 1 by item.id
            style={styles.container} //disabled={item.disabled} true if already seen or viewed by user
        >
            <View style={styles.video}>
                <Image
                    source={VideoMiniature}
                    resizeMode="contain"
                    style={{ width: "100%", height: "100%", borderRadius: 10 }}
                />
                {item?.postType?.code === ArticleTypes.video && (
                    <View
                        style={{
                            position: "absolute",
                            width: "100%",
                            height: "100%"
                            // backgroundColor: "rgba(255,255,255,0.7)"
                        }}
                    >
                        <Ionicons
                            style={{ position: "absolute", top: "30%", bottom: 0, right: "40%" }}
                            name={"play-circle"}
                            color={baseColors.green.primary}
                            size={30}
                        />
                        <OpenSansText
                            numberOfLines={3}
                            fontSize={RFValue(10)}
                            style={{ textAlign: "center", top: "30%", padding: 10 }}
                        >
                            {item.title ?? ""}
                        </OpenSansText>
                    </View>
                )}
            </View>
            <OpenSansText
                fontFamily="OpenSansSemiBold"
                style={{
                    ...styles.label
                }}
                defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                fontSize={16}
            >
                {item.title ?? ""}
            </OpenSansText>
        </TouchableOpacity>
    )
}

export default CustomVideoItem
